import { useFormikContext } from 'formik';
import { isEqual } from 'lodash';

import { useJobContext } from 'hb-react/shared/apps/JobForm/contexts/JobContext';
import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import { IsActive } from 'hb-react/shared/components/IsActive';

import { Contract } from './Contract';
import { Duration } from './Duration';
import { Experience } from './Experience';
import { ExpireDate } from './ExpireDate';
import { Industries } from './Industries';
import { Salary } from './Salary';
import { Section } from './Section';
import { StartDate } from './StartDate';
import { Topics } from './Topics';
import { MODE } from '../constants';
import type { FormValues, ModeValues } from '../types';

export const OtherInfo = ({ mode }: { mode: ModeValues }) => {
  const { values } = useFormikContext<FormValues>();

  const { kindConfigurations = [] } = useJobContext();

  const { fields } =
    kindConfigurations.find(({ kind_id: kindId }) =>
      isEqual(kindId, values.kind_id),
    ) || {};

  const width = { m: 0.5, s: 1 };

  return (
    <Section title={s__('JobForm|Other information')}>
      <Grid mx={0} rowGap={0}>
        <Row>
          <IsActive isActive={fields?.contract_type}>
            <Col width={width}>
              <Contract />
            </Col>
          </IsActive>
          <IsActive isActive={fields?.start_date}>
            <Col width={width}>
              <StartDate />
            </Col>
          </IsActive>
          <IsActive isActive={mode === MODE.BO}>
            <Col width={width}>
              <ExpireDate />
            </Col>
          </IsActive>
          <IsActive isActive={fields?.industries}>
            <Col width={width}>
              <Industries />
            </Col>
          </IsActive>
          <IsActive isActive={fields?.experience_type}>
            <Col width={width}>
              <Experience />
            </Col>
          </IsActive>
          <Salary fields={fields} />
          <IsActive isActive={fields?.duration}>
            <Col width={width}>
              <Duration />
            </Col>
          </IsActive>
          <Topics mode={mode} />
        </Row>
      </Grid>
    </Section>
  );
};
